import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { UserListItem } from '../../../../../ListItem'
import { CopiedToMoreItemIcons } from '../CopiedToMoreItemIcons'

import { isNeedToShowUserItemIcons } from './CopiedToMoreUserItem.utils'

function CopiedToMoreUserItem({
  archived,
  hoverClassName,
  onDelete,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <UserListItem
      {...restProps}
      showTooltip
      Avatar={null}
      Icons={CopiedToMoreItemIcons}
      hoverClassName={hoverClassName}
      iconsProps={{ onDelete }}
      isArchived={archived}
      isNeedToShowIcons={isNeedToShowUserItemIcons}
      tooltipAdditionalText={t('Common.ClickToOpenProfileKey')}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      value={{ ...restProps, archived }}
    />
  )
}

export default CopiedToMoreUserItem
